import MobileDetect from 'mobile-detect'

const detect = new MobileDetect(window.navigator.userAgent)

const useMobile = (): boolean => {
  const isMobile = detect.mobile() && !detect.tablet()
  return !!isMobile
}

export default useMobile
